<div class="flex flex-col items-center p-5 text-center">
  <div class="flex justify-between w-full mb-5">
    <h2 class="text-primary-dark font-bold text-xl">
      {{ data.edit ? 'Atualizar Administrador' : 'Adicionar Novo Administrador' }}
    </h2>
    <button mat-icon-button (click)="close()">
      <mat-icon class="small-icon text-primary-gray">close</mat-icon>
    </button>
  </div>
  <div class="w-full">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" (keydown.enter)="preventEnterSubmit($event)">
      <div class="mb-4 text-left">
        <label for="nomeCompleto" class="input-label">
          Nome Completo
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': userForm.get('nomeCompleto')?.invalid && !nomeFocused && userForm.get('nomeCompleto')?.touched, 'input-field-focus': !(userForm.get('nomeCompleto')?.invalid && !nomeFocused && userForm.get('nomeCompleto')?.touched)}">
          <input id="nomeCompleto" [type]="'text'" formControlName="nomeCompleto" placeholder="Insira o nome completo"
            class="input-element py-3" (focus)="nomeFocused = true" (blur)="nomeFocused = false" />
        </div>
        <div
          *ngIf="userForm.get('nomeCompleto')?.invalid && !nomeFocused && userForm.get('nomeCompleto')?.touched"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="userForm.get('nomeCompleto')?.errors?.['required']">O nome completo é obrigatório.</div>
        </div>
      </div>
      <div class="mb-4 text-left">
        <label for="email" class="input-label">
          E-mail
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': userForm.get('email')?.invalid && !emailFocused && userForm.get('email')?.touched, 'input-field-focus': !(userForm.get('email')?.invalid && !emailFocused && userForm.get('email')?.touched)}">
          <input id="email" type="email" formControlName="email" placeholder="Insira o seu e-mail"
            class="input-element py-3" (focus)="emailFocused = true" (blur)="emailFocused = false" />
        </div>
        <div
          *ngIf="userForm.get('email')?.invalid && !emailFocused && userForm.get('email')?.touched"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="userForm.get('email')?.errors?.['required']">O e-mail é obrigatório.</div>
          <div *ngIf="userForm.get('email')?.errors?.['email']">O e-mail informado não é válido.</div>
        </div>
      </div>
      <div class="mb-4 text-left">
        <label for="cargo" class="input-label">
          Cargo
        </label>
        <div class="input-field"
          [ngClass]="{'input-field-error': userForm.get('roleId')?.invalid && !cargoFocused && userForm.get('roleId')?.touched, 'input-field-focus': !(userForm.get('roleId')?.invalid && !cargoFocused && userForm.get('roleId')?.touched)}">
          <select id="cargo" formControlName="roleId" class="input-element py-3"
            (focus)="cargoFocused = true" (blur)="cargoFocused = false">
            <option value="" disabled selected>Selecione um cargo</option>
            <option *ngFor="let cargo of cargos" [value]="cargo.id">{{ cargo.name }}</option>
          </select>
        </div>
        <div
          *ngIf="userForm.get('roleId')?.invalid && !cargoFocused && userForm.get('roleId')?.touched"
          class="text-red-500 text-sm mt-1">
          <div *ngIf="userForm.get('roleId')?.errors?.['required']">Selecione um cargo.</div>
        </div>
      </div>
      <button type="submit" class="button-compact button-color-primary mt-5 w-full"
        [ngClass]="{'button-disabled': userForm.invalid}" [disabled]="userForm.invalid">
        {{ data.edit ? 'Atualizar Usuário' : 'Adicionar Usuário' }}
      </button>
    </form>
  </div>
</div>